import CardPropertyLink from './CardPropertyLink'
export default CardPropertyLink
